export class SubDistrictModel {
    constructor(public id: string, public name: string, public city_district_id: string){}
}